export const NavCollapseIcon = () => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.75 9H1.5M1.5 9L6.8125 3.6875M1.5 9L6.8125 14.3125"
      stroke="#444444"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5 1L17.5 17"
      stroke="#444444"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
